<app-reactive-dialog-content [data]="dialogInputData">
  <p class="mat-subheading-2 gsm-edit-warning_wrapper">
    <mat-icon color="warn" class="gsm-edit-warning_icon" inline>warning</mat-icon>
    <span [innerHTML]="dialogInputData.data"></span>
  </p>
</app-reactive-dialog-content>
